module.exports = __webpack_public_path__ + "static/media/video-05-tt.aeb7a364.webm";